import { useEffect, useState } from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material'
import ZoomInIcon from '@mui/icons-material/ZoomIn'
import API from '../../../services/API'

const MarkdownS3Image = ({ src, alt }) => {
  const [url, setUrl] = useState('')
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (!src) return

    API.post('/getpublicdownloadurl', {
      key: src,
      inlineView: true,
      expires: 300,
    }).then((res) => {
      setUrl(res.data.url || res.data)
    })
  }, [src])

  if (!url) return null

  return (
    <>
      <Box
        onClick={() => setOpen(true)}
        sx={{
          position: 'relative',
          display: 'inline-block',
          width: 'fit-content',
          maxWidth: '100%',
          my: 2,
          borderRadius: 3,
          overflow: 'hidden',
          cursor: 'pointer',
          boxShadow: '0 10px 28px rgba(15,23,42,0.14)',
          border: '1px solid rgba(15,23,42,0.08)',
        }}
      >
        <Box
          component="img"
          src={url}
          alt={alt || ''}
          sx={{
            display: 'block',
            maxWidth: '100%',
            maxHeight: 260,
            objectFit: 'contain',
            opacity: 0.45,
            filter: 'blur(0.4px)',
          }}
        />

        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'rgba(15,23,42,0.18)',
          }}
        >
          <Button
            variant="contained"
            startIcon={<ZoomInIcon />}
            sx={{
              borderRadius: 999,
              fontWeight: 800,
              textTransform: 'none',
            }}
          >
            Click to view
          </Button>
        </Box>
      </Box>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="xl"
        fullWidth
      >
        <DialogContent sx={{ p: 0, bgcolor: '#020617' }}>
          <Box
            component="img"
            src={url}
            alt={alt || ''}
            sx={{
              width: '100%',
              maxHeight: '90vh',
              objectFit: 'contain',
              display: 'block',
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpen(false)}
            variant="contained"
            color="error"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default MarkdownS3Image
